import { Checkbox } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: scroll;

  flex: 1;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  max-width: 600px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: column;
    max-width: 800px;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.lg}) {
    min-width: 516px;
    padding: 20px 0 20px 60px;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.green6} !important;
    border-color: ${({ theme }) => theme.colors.green6} !important;
  }
  .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: ${({ theme }) => theme.colors.white} !important;
  }
  .ant-checkbox-inner {
    border-radius: 4px;
    width: 16px;
    height: 16px;
  }
  .ant-checkbox-inner::after {
    left: 22%;
    top: 45%;
    width: 7px;
    height: 12px;
    border-width: 0 2px 2px 0;
  }
`;
